import { FieldInputProps } from 'formik';

import { Box, TextField } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

export const DOCUMENT_ACTION_MESSAGE_MAX_LENGTH = 250;

type DocumentActionMessageFieldProps = FieldInputProps<string> & {
  id: string;
  disabled: boolean;
  error?: string;
};

export default function DocumentActionMessageField({
  id,
  disabled,
  error,
  ...fieldProps
}: DocumentActionMessageFieldProps) {
  const { t } = useLocales();

  return (
    <TextField
      variant="outlined"
      fullWidth
      disabled={disabled}
      label={t('shared.fields.message')}
      {...fieldProps}
      error={Boolean(error)}
      helperText={
        <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
          <span>{error}</span>
          <span>{`${fieldProps.value.length}/${DOCUMENT_ACTION_MESSAGE_MAX_LENGTH}`}</span>
        </Box>
      }
      slotProps={{ htmlInput: { maxLength: DOCUMENT_ACTION_MESSAGE_MAX_LENGTH } }}
      size="small"
      type="text"
      id={id}
    />
  );
}
